export const setCommercialPermits = (state, payload) => {
  state.commercialPermits = payload.map((permit) => {
    // convert bools
    permit.ownerIsContact = Number(permit.ownerIsContact)
    permit.activePrior = Number(permit.activePrior)
    return permit
  })
}
export const setPeopleByCommercialPermit = (state, payload) => {
  state.people = payload
}
